import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isRenderingForMobileApp } from 'src/constants';
import { ZipYiService } from '~services';
import { ZipYiContext } from '~services/biocatch/zip-yi-context.enum';

@Component({
  selector: 'app-pending',
  templateUrl: './pending.component.html',
  styleUrls: ['./pending.component.scss', '../../../scss/error.styling.scss'],
  standalone: false,
})
export class PendingComponent implements OnInit {
  appPrefix = environment.appPrefix;
  isMobileRender = isRenderingForMobileApp;

  constructor(private zipYiService: ZipYiService) {}

  ngOnInit(): void {
    this.zipYiService.setContext(ZipYiContext.PurchasePendingPage);
  }
}
